<section class="container-style">
  <form [formGroup]="formEnterpriseCity">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <app-custom-audit-info [userNameCreate]="enterpriseCityContract.userNameCreate"
          [createDate]="enterpriseCityContract.createDate" [userNameUpdate]="enterpriseCityContract.userNameUpdate"
          [updateDate]="enterpriseCityContract.updateDate"
          [reserveSpace]="true"></app-custom-audit-info>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-12 col-sm-4 col-6">
        <app-custom-autocomplete formControlName="departmentId" [labelText]="'Departamento'" [list]="listDepartments"
          [required]="true" [recovery]="true" (onChangeSelect)="changeDepartment($event)">
        </app-custom-autocomplete>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-4 col-6">
        <app-custom-autocomplete formControlName="cityId" [labelText]="'Ciudad'" [list]="listCities" [required]="true"
          [recovery]="true" (onChangeSelect)="changeCity($event)">
        </app-custom-autocomplete>
      </div>
      <div class="col-lg-2 col-md-1 col-sm-1 col-6 d-flex align-items-end">
        <app-custom-checkbox formControlName="swIcaSelfRetainer" [labelText]="'Autorre.ICA'"></app-custom-checkbox>
      </div>
      <div class="col-lg-2 col-md-12 col-sm-12 col-12 d-flex justify-content-end align-items-end gap-2 mt-sm-2 mt-md-3">
        <app-custom-button [label]="'Guardar'" [severity]="'primary'" [variant]="undefined" [disabled]="disabled"
          (onClick)="send()"></app-custom-button>
        <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="cancel()"></app-custom-button>
      </div>
    </div>
  </form>
</section>